import { render, staticRenderFns } from "./diyExamine.vue?vue&type=template&id=cb7ca590&scoped=true&"
import script from "./diyExamine.vue?vue&type=script&lang=js&"
export * from "./diyExamine.vue?vue&type=script&lang=js&"
import style0 from "./diyExamine.vue?vue&type=style&index=0&id=cb7ca590&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7ca590",
  null
  
)

export default component.exports